<div class="content-loaf">
  <h2>動画配信更新</h2>
  <hr />

  <div class="row content-block">
    <div class="col-12">
      <p>
        下のテキストボックスに動画配信のURLを貼り付け、更新ボタンを押してください。<br />
        テキストボックスを空にして更新を行うと、参照ユーザーの画面上で動画配信のボタンが非表示となります。
      </p>

      動画配信URL：
      <input name="saiki-tube-url" type="text" [(ngModel)]="urlInfo.url" />

      <div class="text-right">
        <i *ngIf="isUpdating" class='fa fa-circle-o-notch fa-spin'></i>
        <button name="url-update" class="btn btn-primary btn-primary-gradient" [disabled]="isUpdating" (click)="update()">更新</button>
      </div>
    </div>
  </div>
</div>
